export default __webpack_public_path__ + "static/media/register.fb72ab99.jpg";